<main class="main">
    <div class="page-header text-center img-style" >
        <div class="container">
            <h1 class="page-title">My Account<span>Shop</span></h1>
        </div>
    </div>
    <nav class="breadcrumb-nav mb-3">
        <div class="container">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a routerLink="/">Home</a>
                </li>
                <!--
                <li class="breadcrumb-item">
                    <a routerLink="/shop/sidebar/3cols">Shop</a>
                </li>
                -->
                <li class="breadcrumb-item active">My Account</li>
            </ol>
        </div>
    </nav>

    <div class="page-content">
        <div class="dashboard">
            <div class="container">
                <div class="row">
                    <aside class="col-md-4 col-lg-3">
                        <ul class="nav nav-dashboard flex-column mb-3 mb-md-0" role="tablist" tabClick>
                            <li class="nav-item">
                                <a class="nav-link active" href="javascript:;" role="tab"
                                    (click)="nav.select('tab-1')">Dashboard</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="javascript:;" role="tab"
                                    (click)="nav.select('tab-2')">Orders</a>
                            </li>
                            <!--
                            <li class="nav-item">
                                <a class="nav-link" href="javascript:;" role="tab"
                                    (click)="nav.select('tab-3')">Downloads</a>
                            </li>
                            -->
                            <li class="nav-item">
                                <a class="nav-link" href="javascript:;" role="tab"
                                    (click)="nav.select('tab-4')">Adresses</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="javascript:;" role="tab" (click)="nav.select('tab-5')">Account
                                    Details</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="javascript:;" role="tab" (click)="nav.select('tab-6')">Reward Points</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" (click)="signoutClicked($event)">Sign Out</a>
                            </li>
                        </ul>
                    </aside>

                    <div class="col-md-8 col-lg-9">
                        <div class="tab-content">
                            <ul ngbNav #nav="ngbNav">
                                <!-- ***************************** DASHBOARD SECTION **************************************************-->
                                <li [ngbNavItem]="'tab-1'">
                                    <ng-template ngbNavContent>
                                        <p>Hello <span class="font-weight-normal text-dark">{{apiService.userInfo[0].CUSTNAME}}</span> (not <span
                                                class="font-weight-normal text-dark">{{apiService.userInfo[0].CUSTNAME}}</span>? <a
                                                routerLink="/" (click)="signoutClicked($event)">Log out</a>)
                                            <br>
                                            From your account dashboard you can view your <a href="javascript:;"
                                                (click)="nav.select('tab-2'); viewTab( $event, 0, 1 );"
                                                class="tab-trigger-link link-underline">recent orders</a>, manage your
                                            <a href="javascript:;"
                                                (click)="nav.select('tab-4'); viewTab( $event, 0, 2 );"
                                                class="tab-trigger-link">shipping and billing addresses</a>, and <a
                                                href="javascript:;"
                                                (click)="nav.select('tab-5'); viewTab( $event, 0, 3 );"
                                                class="tab-trigger-link">edit your password and account details</a>.</p>                                                
                                    </ng-template>
                                </li>

                                <!-- ***************************** ORDERS SECTION **************************************************-->
                                <li [ngbNavItem]="'tab-2'">
                                    <ng-template ngbNavContent>
                                        <p *ngIf="apiService.usersOrders?.length == 0">No order has been made yet.</p>
                                        <div class="container mt-5" *ngIf="apiService.usersOrders?.length > 0">
  
                                            <h4>Your Orders</h4>
                                            
                                            <table class="table table-striped table-width" >
                                              <thead>
                                                  <tr>
                                                    <th>Code</th>
                                                    <th>Description</th>
                                                    <th>Date/Time</th>                                                    
                                                    <th>Price</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                <tr *ngFor="let order of apiService.usersOrders">
                                                  <td>{{ order.ORDERCODE }}</td>
                                                  <td>
                                                    <ul>
                                                        <li *ngFor="let details of order.orderDetails">
                                                            {{details.PRODDESC}} x {{details.ORDERDQTTY}}
                                                        </li>
                                                    </ul>
                                                  </td>
                                                  <td>{{ order.ORDERDT }}</td>                                                  
                                                  <td>{{ order.ORDERTOTAL | currency:'EUR':'symbol':'1.2-2'}}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        <a routerLink="/shop/sidebar/list" class="btn btn-outline-primary-2"><span>GO
                                                SHOP</span><i class="icon-long-arrow-right"></i></a>
                                    </ng-template>
                                </li>

                                <!-- ***************************** DOWNLOADS -REMOVED- SECTION **************************************************-->
                                <li [ngbNavItem]="'tab-3'">
                                    <ng-template ngbNavContent>
                                        <p>No downloads available yet.</p>
                                        <a routerLink="/shop/sidebar/list" class="btn btn-outline-primary-2"><span>GO
                                                SHOP</span><i class="icon-long-arrow-right"></i></a>
                                    </ng-template>
                                </li>

                                <!-- ***************************** ADDRESSES SECTION **************************************************-->                                <li [ngbNavItem]="'tab-4'">
                                    <ng-template ngbNavContent>
                                        <p>The following addresses will be used on the checkout page by default.</p>

                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="card card-dashboard">
                                                    <div class="card-body">
                                                        <h3 class="card-title">Billing Address</h3>

                                                        <p> {{apiService.userInfo[0].CUSTNAME}} <br>                                                            
                                                            {{apiService.userInfo[0].CUSTADDRESS}}<br>
                                                            {{apiService.userInfo[0].CUSCITY}}, {{apiService.userInfo[0].CUSTCOUNTRY}}<br>
                                                            {{apiService.userInfo[0].CUSTMOBILEPHONE}}<br>
                                                            {{apiService.userInfo[0].CUSTEMAIL}}<br>
                                                            <a href="javascript:;"
                                                            (click)="nav.select('tab-5'); viewTab( $event, 2, 3 );">
                                                            Edit <i class="icon-edit"></i></a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--
                                            <div class="col-lg-6">
                                                <div class="card card-dashboard">
                                                    <div class="card-body">
                                                        <h3 class="card-title">Shipping Address</h3>

                                                        <p>You have not set up this type of address yet.<br>
                                                            <a href="javascript:;">Edit <i class="icon-edit"></i></a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            -->
                                        </div>
                                    </ng-template>
                                </li>

                                <!-- ***************************** ACCOUNT DETAILS SECTION **************************************************-->
                                <li [ngbNavItem]="'tab-5'">
                                    <ng-template ngbNavContent>
                                        <form action="#">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <label>First Name *</label>
                                                    <input type="text" class="form-control" id="fname" value="{{apiService.userInfo[0].CUSTNAME}}" required>
                                                </div>

                                                <div class="col-sm-6">
                                                    <label>Last Name *</label>
                                                    <input type="text" class="form-control" id="lname" value="{{apiService.userInfo[0].CUSTSURNAME}}" required>
                                                </div>
                                            </div>

                                            <label>Address *</label>
                                            <input type="text" class="form-control" id="address" value="{{apiService.userInfo[0].CUSTADDRESS}}" required>

                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <label>City *</label>
                                                    <input type="text" class="form-control" id="city" value="{{apiService.userInfo[0].CUSTCITY}}" required>
                                                </div>

                                                <div class="col-sm-6">
                                                    <label>Country *</label>
                                                    <input type="text" class="form-control" id="country" value="{{apiService.userInfo[0].CUSTCOUNTRY}}" required>
                                                </div>
                                            </div>

                                            <label>Email address *</label>
                                            <input type="email" class="form-control" id="email" value="{{apiService.userInfo[0].CUSTEMAIL}}" required>

                                            <label>Current password (leave blank to leave unchanged)</label>
                                            <input type="password" id="currentPass" class="form-control">

                                            <label>New password (leave blank to leave unchanged)</label>
                                            <input type="password" id="newPass" class="form-control">

                                            <label>Confirm new password</label>
                                            <input type="password" id="newPass2" class="form-control mb-2">

                                            <button type="submit" class="btn btn-outline-primary-2" (click)="saveClicked($event)">
                                                <span>SAVE CHANGES</span>
                                                <i class="icon-long-arrow-right"></i>
                                            </button>
                                        </form>
                                    </ng-template>
                                </li>
                                <!-- ***************************** Reward Points **************************************************-->
                                <li [ngbNavItem]="'tab-6'">
                                    <ng-template ngbNavContent>
                                        <div class="card card-dashboard">
                                            <div class="card-body">
                                                <h3 class="card-title">Reward Points</h3><br>
                                                <p>Your reward points worth : <b>€{{points | number:'1.2-2'}}</b></p>
                                                <p>You can redeem your points on the <a href="/shop/cart">checkout page</a>, after selecting the shipping method, by typing the amount in euros you want to redeem.</p>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                            </ul>
                            <div [ngbNavOutlet]="nav"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>